import { useState } from 'react';
import ProctoringTable from './components/tables/ProctoringTable';
import { useQuery } from 'react-query';
import reportApi from '../../api/report';
import { CandidateTestDetails, FileStartsProps} from './report-models/report.interface';

const ProctoringData = () => {
  const institutionId = Number(localStorage.getItem('c-iid')) || -1;
  const testId = Number(sessionStorage.getItem('testId')) || -1;
  const candidateId = Number(sessionStorage.getItem('candidateId')) || -1;
  const periodId = Number(sessionStorage.getItem('periodId')) || -1;
  const subjectId = Number(sessionStorage.getItem('subjectId')) || -1;
  const categoryId = Number(sessionStorage.getItem('categoryId')) || -1;
  const [candidates, setCandidates] = useState<CandidateTestDetails[]>([]);
  const [fileStats, setFileStats] = useState<FileStartsProps[]>([{fileName: '', itemCount: 0, sizeMb: "0", lastUpdated: ""}]);

  useQuery({
    queryKey: ['getTestDetails', institutionId, testId, periodId, subjectId],
    queryFn: async () =>
      reportApi.getTestDetail(institutionId, testId, subjectId, periodId, categoryId),
    onSuccess(data) {
      const candidateDetails = data.data
        .details as unknown as CandidateTestDetails[];
      const CandidateTestDetails = candidateDetails.filter(
        (candidate) => candidate.candidateId === candidateId
      );
      setCandidates(CandidateTestDetails);
    },
    enabled: !!testId && !!institutionId && !!(testId > 0),
  });

  useQuery({
    queryKey: ['getFileStats', candidateId, testId],
    queryFn: async () => reportApi.getFileStats(candidateId, testId),
    onSuccess(data) {
      setFileStats(data);
    },
    enabled: !!testId && !!candidateId && !!(testId > 0),
  });

  return (
    <div>
      <ProctoringTable data={candidates} fileStats={fileStats} />
    </div>
  );
};

export default ProctoringData;
